import React, {Component} from 'react';
import {Cell, Label, Legend, Pie, PieChart, ResponsiveContainer, Tooltip} from 'recharts';
import {MONTHLY_CLAIMS, WHITOUT_INFORMATION} from '../utils/constants';
import * as Request from '../service/data-info-chart/requestsUtil';

var Loader = require('react-loader');


class TotalCLaims extends Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loaded: false,
      date: this.props.date,
    };
  }

  componentDidMount() {
    Request.getFetch(MONTHLY_CLAIMS + this.props.date)
      .then((data) => {
        this.setState({
          data: data.claimsPls,
          numberClaims: data.totalClaims,
          loaded: true
        });
        this.props.callbackFromParent(data);
      });
  }

  render() {

    const colors = [
      ['#ff0000'],
      ['#0000ff'],
      ['#00ff00'],
      ['#ff6600'],
    ];

    let claims = [];

    if (this.state.data !== []) {
      this.state.data.map((bu) => {
        return claims.push({
          quantity: bu.numberClaims,
          type: bu.namePlaza
        });
      });
    }

    const RADIAN = Math.PI / 180;
    const renderCustomizedLabel = ({cx, cy, midAngle, innerRadius, outerRadius, percent, index}) => {
      const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
      const x = cx + radius * Math.cos(-midAngle * RADIAN);
      const y = cy + radius * Math.sin(-midAngle * RADIAN);

      return (
        <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'}
              dominantBaseline="central">
          {`${(percent * 100).toFixed(0)}%`}
        </text>
      );
    };

    if (claims.length > 0) {

      let notZero = 0;

      claims.forEach(val=>{
        notZero+=val.quantity
      });

      let pie = notZero > 0 ? <ResponsiveContainer>
        <PieChart height={500} width={500}>
          <Tooltip/>
          <Label position={'inside'}/>
          <Legend verticalAlign="top" align="left" height={50} width={150}/>
          <Pie data={claims} dataKey={'quantity'} nameKey={'type'} innerRadius={100}
               outherRadius={55}
               labelLine={false} label={renderCustomizedLabel}>
            {
              claims.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={colors[index]}/>
              ))
            }
          </Pie>
        </PieChart>
      </ResponsiveContainer> : '';


      return (
        <div key={this.props.key} style={{
          paddingBottom: '0%', /* 16:9 */
          position: 'relative',
          textAlign: 'center',
          height: 500
        }}>
          <div style={{
            position: 'absolute',
            top: '0',
            left: '0',
            width: '100%',
            height: '100%',
            marginTop: '0%',
          }}>
            {pie}
            <div className='title-pie'>
              <h2>{this.state.numberClaims}</h2><p> Reclamaciones</p> <p>totales</p>
            </div>
          </div>
        </div>
      );
    }
    else {
      return (<Loader loaded={this.state.loaded} top="50%"><h2
        className="without-avilable-information">{WHITOUT_INFORMATION}</h2></Loader>);
    }
  }

}

export default TotalCLaims;



// WEBPACK FOOTER //
// ./src/charts/totalClaims.js